import React from "react";
import { Navigate } from "react-router-dom";
import type { RouteConfig } from "./types";

export const homeRoutes: RouteConfig[] = [
	{
		path: "/home",
		element: <Navigate to="/task-list/downday" replace />,
	},
];
